<template>
    <div>

<!--        <b-progress :value="progress" :max="100"></b-progress>-->

        <div v-if="loading" class="text-center"><img src="/loading.svg" /><p>Loading...</p></div>
        <div v-else class="text-center">

            <div style="overflow: hidden;">
                <transition name="slide-fade" mode="out-in">
                    <h1 style="font-size: 2.5em;" :key="name">{{name}}</h1>
                </transition>
            </div>
            <b-button @click="copyName" variant="primary" class="mt-2">Copy</b-button>

            <div class="row my-5 align-items-stretch">
                <div class="col-6 col-md-4 col-lg-2 pb-2" v-for="(value, key) in options" :key="key">
                    <b-button
                        @click="pickRandomNameFromCategory(key)"
                        variant="info"
                        class="w-100 h-100 m-1 p-3"
                    >
                        <img :src="'/icons/' + categoryIcons[key] + '.svg'" style="height: 40px;">
                        <span class="mt-3 d-block">{{ key }}</span>
                    </b-button>
                </div>
            </div>

            <p class="mt-5">You can also name your team after a <strong>skill set</strong> like "Code Warriors", a <strong>business goal</strong> like "Sales Avengers", an <strong>event</strong> like "Hackathon Heroes", or a <strong>company value</strong> like "Integrity Squad".</p>

        </div>
    </div>
</template>
<style scoped>
.slide-fade-enter-active, .slide-fade-leave-active {
    transition: transform 0.5s ease-in-out; /* Reduced time to 0.5s for faster animation */
}
.slide-fade-enter {
    transform: translateY(-100%); /* Starts from top */
}
.slide-fade-leave-to {
    transform: translateY(100%); /* Goes to bottom */
}
</style>

<script>
import NotificationPop from '../mixins/NotificationPop.js'

export default {
    name: "TeamNameTool",
    mixins: [NotificationPop],
    components: {
    },

    data() {
        return {
            loading: true,
            name: null,
            categoryIcons: {
                'Natural Elements': 'fire',
                'Sci-Fi & Fantasy': 'superhero',
                'Sports & Games': 'football',
                'Animals': 'lion',
                'Historical Figures': 'roman',
                'Travel & Adventure': 'pyramid',
            },
            options: {
                "Natural Elements": [
                    "Team Thunder", "Fiery Phoenix", "Ocean's Eleven", "Wind Warriors", "Earthshakers",
                    "Ice Titans", "Mountain Monarchs", "River Runners", "Solar Flares", "Lunar Legends",
                    "Team Tornado", "Blazing Suns", "Comet Catchers", "Forest Fiends", "Lake Legends",
                    "Coral Commanders", "Hail Heroes", "Mist Mystics", "Lava Lords", "Dune Dominators",
                    "Cloud Cruisers", "Winter Wolves", "Prairie Predators", "Tidal Titans", "Desert Dragoons",
                    "Stormy Surfers", "Lightning Leaders", "Volcanic Vandals", "Eclipse Enforcers", "Rock Riders",
                    "Woodland Warriors", "Dewdrop Divas", "Cosmic Champions", "Floral Fighters", "Glacial Giants",
                    "Sunset Surfers", "Vortex Victors", "Aurora Avengers", "Reef Raiders", "Starlight Soldiers",
                    "Snowy Sages", "Rainbow Rebels", "Magma Masters", "Heatwave Heroes", "Skyline Spartans",
                    "Highland Heroes", "Rain Rulers", "Twilight Titans", "Meteor Marauders", "Seaside Spartans",
                    "Foggy Frontiersmen"
                ],
                "Sci-Fi & Fantasy": [
                    "Galactic Guardians", "Team Starship", "Elven Elite", "Cybernetic Squad", "Dragonborn Dominion",
                    "Martian Marauders", "Nebula Navigators", "Vulcan Vanguard", "Wizard Watch", "Sith Syndicate",
                    "Jedi Juggernauts", "Orbital Outlaws", "Time Travellers", "Spellbinders", "Cosmic Crusaders",
                    "Astro Avengers", "Dimensional Drifters", "Warp Warriors", "Fantasy Flyers", "Quasar Questers",
                    "Celestial Soldiers", "Magic Makers", "Goblin Gang", "Shadow Sorcerers", "Moonlight Marauders",
                    "Extraterrestrial Elite", "Merlin's Minions", "Pixie Power", "Stellar Seekers", "Temporal Titans",
                    "Gryffindor Glory", "Slytherin Squad", "Fellowship of the Team", "Zombie Zappers", "Laser Legion",
                    "Robot Rebels", "Treasure Trackers", "Quest Quenchers", "Interstellar Invaders", "UFO Unifiers",
                    "Oracle Operatives", "Space Spartans", "Orc Offense", "Rune Raiders", "Dwarven Defenders",
                    "Heroic Heralds", "Chosen Champions", "Dream Drifters", "Mystic Masters", "Lore Legends"
                ],
                "Sports & Games": [
                    "Pinball Wizards", "Slam Dunkers", "Chess Champs", "Soccer Sultans", "Poker Aces",
                    "Rugby Renegades", "Bowling Bunch", "Archery Army", "Tennis Titans", "Golf Gurus",
                    "MVP Marvels", "Snooker Sharks", "Baseball Bats", "Volleyball Victors", "Cricket Crew",
                    "Cycling Cyclones", "Hiking Heroes", "Skateboard Squad", "Gaming Geeks", "Boardgame Bosses",
                    "Cardsharp Collective", "Martial Artists", "Boxing Band", "Fitness Fanatics", "Paddle Prowess",
                    "Yoga Yodhas", "Ping Pong Pros", "Surfing Squad", "Snowboard Saints", "Skiing Stars",
                    "Billiard Ballers", "Diving Dolphins", "Sailing Savants", "Racing Runners", "Horseback Heroes",
                    "Kayaking Kings", "Frisbee Fanatics", "Dodgeball Demons", "Pilates Peers", "Zumba Zombies",
                    "Gymnast Giants", "Rollerblade Runners", "Hockey Hawks", "Darts Daredevils", "Rock Climbing Rangers",
                    "Paintball Paladins", "Kickball Kings", "Wrestling Warriors", "Lacrosse Legends", "Badminton Buddies"
                ],
                "Animals": [
                    "Cheetah Sprint", "Eagle Eye", "Wolf Pack", "Dolphin Dive", "Kangaroo Hop",
                    "Lion's Roar", "Elephant Memory", "Turtle's Pace", "Bear Grind", "Falcon Focus",
                    "Monkey Magic", "Snake Slither", "Penguin Parade", "Zebra Zone", "Giraffe Giants",
                    "Hippo Haven", "Rhino Rampage", "Owl Observers", "Flamingo Flamenco", "Badger Brigade",
                    "Tiger Team", "Fox Force", "Bison Bunch", "Jaguar Jump", "Lemur Leap",
                    "Hedgehog Heroes", "Bat Binge", "Polar Bear Plunge", "Octopus Orchestra", "Crocodile Crew",
                    "Swan Soiree", "Shark Squad", "Rabbit Racers", "Goat Gang", "Moose Mountain",
                    "Sloth Slowdown", "Walrus Wave", "Horse Herd", "Beaver Builders", "Platypus Party",
                    "Raccoon Rally", "Lynx Links", "Otter Oasis", "Weasel Whirl", "Camel Caravan",
                    "Cobra Clan", "Seal Splash", "Hamster Huddle", "Panda Pals", "Ant Army"
                ],
                "Historical Figures": [
                    "Team Tesla", "Einstein Enthusiasts", "Cleopatra's Crew", "Knightly Nobles", "Da Vinci Disciples",
                    "Lincoln Leaders", "Caesar's Circle", "Napoleon's Army", "Queen's Court", "Shakespearean Souls",
                    "Washington Warriors", "Freud's Friends", "Mozart Maestros", "Curie's Chemists", "Picasso's Painters",
                    "Homer's Heroes", "Tubman's Trailblazers", "Socrates' Students", "Hannibal's Horde", "Confucius Clan",
                    "Frida's Fighters", "Joan of Arc Angels", "Gandhi's Gang", "Mandela's Movement", "Beethoven's Band",
                    "Darwin's Disciples", "Franklin's Flyers", "Copernicus Crew", "Churchill's Champions", "Archimedes Army",
                    "Hemingway's Heroes", "Tolkien's Troops", "Poe's Poets", "King's Dreamers", "Plato's Pupils",
                    "Jane Austen Admirers", "Nightingale Nurses", "Rosa's Rebels", "Luther's Liberators", "Oscar Wilde Ones",
                    "Earhart's Aviators", "Bach's Bunch", "Descartes' Disciples", "Malcolm's Militants", "Machiavelli's Men",
                    "Monet's Muses", "Thoreau's Thinkers", "Guevara's Guerrillas", "Kant's Philosophers", "Roosevelt's Riders"
                ],
                "Travel & Adventure": [
                    "Trailblazers", "Globe-trotting Gang", "Summit Seekers", "Desert Drifters", "Island Explorers",
                    "Vagabond Vipers", "Safari Squad", "Mountain Movers", "Wanderlust Warriors", "Ocean's Offspring",
                    "Skydiving Squad", "Backpacker Battalion", "Roadtrip Rovers", "Nomadic Navigators", "Expedition Experts",
                    "Snowy Summiters", "Tropical Trailblazers", "Cave Crawlers", "Jungle Journeymen", "Beach Bums",
                    "Paragliding Pros", "Reef Rangers", "Canoe Crew", "Cruise Captains", "Volcano Venturers",
                    "Glacier Gliders", "Forest Foragers", "Urban Adventurers", "Valley Voyagers", "Prairie Pioneers",
                    "Rafting Renegades", "Eco Explorers", "Marshland Marauders", "Space Seekers", "Seaside Sailors",
                    "Coral Conquerors", "Lake Lovers", "Aurora Admirers", "Tundra Trekkers", "Moonwalk Masters",
                    "Canyon Climbers", "Sunset Surfers", "Waterfall Wonders", "Nature's Nomads", "Dune Drifters",
                    "Skyline Skippers", "Night Sky Navigators", "Savanna Sprinters", "Cliffhanger Crew", "Starship Soarers"
                ]
            }
        }
    },

    async created() {
        this.loading = false;
        this.pickRandomName()
        // select random
    },
    methods: {

        pickRandomNameFromCategory(category) {
            const names = this.options[category];
            if (names) {
                const randomIndex = Math.floor(Math.random() * names.length);
                this.name = names[randomIndex];
            }
        },

        pickRandomName() {
            // Get all categories
            const categories = Object.keys(this.options);

            // Pick a random category
            const randomCategoryIndex = Math.floor(Math.random() * categories.length);
            const randomCategory = categories[randomCategoryIndex];

            // Pick a random name from the selected category
            const names = this.options[randomCategory];
            const randomNameIndex = Math.floor(Math.random() * names.length);

            // Set the random name
            this.name = names[randomNameIndex];
        },

        /**
         * Copy key
         */
        copyName: function () {
            let main = this
            this.$copyText(this.name).then(function (e) {
                main.popNotification('Copied', 'success')
            }, function (e) {
                main.popNotification('Can not copy', 'danger')
            })
        },


    }
}
</script>